// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3GR3F","title":"FrontImage_title__oDDjR"};